export var VgsFormFieldName;
(function (VgsFormFieldName) {
    VgsFormFieldName["Expiration"] = "variables.cardData";
    VgsFormFieldName["Number"] = "variables.cardData.number";
    VgsFormFieldName["CVC"] = "variables.cardData.cvv";
    VgsFormFieldName["Zip"] = "variables.cardData.zip";
})(VgsFormFieldName || (VgsFormFieldName = {}));
